import type { CustomerDetail } from '@/features/intelligence/types';
import type { AccountHealth } from '../types';

function getTrendDirection(
  trendDelta: number | null | undefined,
  fallback: AccountHealth['trend']
): AccountHealth['trend'] {
  if (typeof trendDelta !== 'number') {
    return fallback;
  }

  if (trendDelta > 5) {
    return 'up';
  }

  if (trendDelta < -5) {
    return 'down';
  }

  return 'stable';
}

export function resolveAccountHealth(
  dashboardHealth: AccountHealth,
  customerDetail?: Pick<CustomerDetail, 'health_score' | 'trend'> | null
): AccountHealth {
  return {
    ...dashboardHealth,
    score: customerDetail?.health_score ?? dashboardHealth.score,
    trend: getTrendDirection(customerDetail?.trend, dashboardHealth.trend),
  };
}
